import {useAuth} from "../../providers/authprovider";
import React, {useEffect, useState} from "react";
import {Alert, Button, Col, Form, Row, Table} from "react-bootstrap";
import AddressForm from "../../components/AddressForm";
import  { PersonTable} from "../../components/PersonForm";
import {
    Link, useNavigate, useSearchParams
} from "react-router-dom";
import getDateForInputFromMysqlDate from "../../utils/utils";
import ResponseAlert from "../../components/ResponseAlert";
import {Typeahead} from "react-bootstrap-typeahead";
import {v4 as uuidv4} from "uuid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import { BuildingFilesForm } from "../../components/BuildingFilesForm";
import { BuildingProtocolFilesGrid } from "../../components/BuildingProtocolAttachmentsGrid";

function deepClone(obj){
    return JSON.parse(JSON.stringify(obj));
}

export default function AddBuildingForm(props){
    const [searchParams] = useSearchParams();
    const {privilege, teams} = props;
    const navigate = useNavigate();
    const {clients : {getShort : getShortClientsInfo, getClient}, buildings : { add}} = useAuth();
    const [validated, setValidate] = useState(false);
    const [clients, setClients] = useState(undefined);
    const [alert, setAlert] = useState({show:false, error:""})
    const [formData, setFormData] = useState(()=>{

        if(props.building !== undefined)
            return deepClone(props.building);

        return {client_id:searchParams.get("clientId"),name:'', status:'aktywny',
            folder_num:'',description:'',agreement_date:'', project_num:'',
            agreement_end_date:'',agreement_indefinite:0,
            address:{}, persons:[], inspections:[]
        }
    });

    const BUILDING_EDITION = props.building !== undefined;


    useEffect(()=>{
        if(clients!== undefined)
            return;

        getShortClientsInfo((response)=>{
            if(!response.success)
                return;

            setClients(response.content);

            if(searchParams.get("clientId"))
                getClient(formData.client_id, (response)=>{
                    if(response.success){
                        setFormData(
                            {
                                ...formData,
                                persons:response.content.persons,
                                address: {...response.content.address, id: uuidv4()}
                            })
                    }
                })
        })
    })

    const handleSaveBuilding = (event)=>{

        event.preventDefault();
        event.stopPropagation();


        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            add(formData, BUILDING_EDITION, ({success, error, content})=>{
                if(success && props.onBuildingSaved){
                    props.onBuildingSaved(content);
                    navigate("/buildings", {replace: true})
                } else
                    setAlert({show:true, error: error})

            })
        }

        setValidate(true)
    }

    const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onChangeAddresState = (data)=>{
        setFormData({...formData, address:data.address})
    }

    const handlePersonChange = (persons)=>{
        setFormData({...formData, persons:persons});
    }

    const handleSelectClient = (options)=>{

        if (options.length <= 0)
            return;

        let {id} = options[0];


        formData.client_id = id;

        setFormData({...formData});


        getClient(id, (response)=>{
            if(response.success){
                const persons = formData.persons !== undefined ? [...formData.persons, ...response.content.persons] : response.content.persons;
                const address = Object.keys(formData.address).length > 0 ? formData.address : {...response.content.address, id:uuidv4()};
                setFormData({...formData, persons:persons, address:address})
            }
        })
    }

    const getDefaultClientValue = ()=>{
        if(formData.client_id === undefined)
            return "";

        const client = clients.find(c=>c.id === formData.client_id);

        if(client === undefined)
            return "";

        return client.name;
    }

    const handleCheckAgrrementEndDate = (e)=>{
        setFormData({...formData, agreement_indefinite:e.target.checked ? 1: 0});
    }

    const handleEditInspection = (inspection)=>{
        setFormData((prevState)=>{
            const inspections = prevState.inspections === undefined ? [] : [...prevState.inspections];

            const pos = inspections.findIndex(i=>i.id === inspection.id);

            if(pos > -1)
                inspections.splice(pos, 1, inspection)
            else {
                inspection.team_id = formData.team_id;
                inspections.push(inspection)
            }


            return {...prevState, inspections: [...inspections]};
        })
    }

    const handleDeleteInspection = (inspectionId)=>{
        setFormData((prevState)=>{
            const inspectionIndex = prevState.inspections.findIndex(inspection=>inspection.id === inspectionId);

            if(inspectionIndex < 0)
                return {prevState};



            const inspections = [...prevState.inspections];
            inspections.splice(inspectionIndex, 1);
            return {...prevState, inspections: [...inspections]};

        })
    }

    if(clients !== undefined)
        return (
            <Form disabled noValidate validated={validated} action={"post"} onSubmit={handleSaveBuilding}>
                <div>
                    <div className={"p-2"}>
                        <ResponseAlert show={alert.show} error={alert.error} />
                        <Row className={"m-2 border"}>
                            <div className={"border bg-light fs-5"}>
                                Dane podstawowe
                            </div>
                            <Col lg={4}>
                                <Form.Group className="mb-3" controlId="client_select">
                                    <Form.Label>Kontrahent (obsługujacy obiekt)</Form.Label>
                                    <Typeahead
                                        id="basic-typeahead-single"
                                        labelKey="name"
                                        onChange={handleSelectClient}
                                        defaultInputValue={getDefaultClientValue()}
                                        options={clients}
                                        required={true}
                                        placeholder="Wybierz klienta..."
                                    />
                                </Form.Group >
                            </Col>
                            <Col lg={4}>
                                <Form.Group className="mb-3" controlId="building.name">
                                    <Form.Label>Nazwa obiektu</Form.Label>
                                    <Form.Control required
                                                  type="text"
                                                  name={"name"}
                                                  placeholder="nazwa"
                                                  defaultValue={formData.name}
                                                  onChange={handleChange}/>

                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.status">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select defaultValue={formData.status} required={true} onChange={handleChange} name={"status"}
                                                 aria-label="Default select example">
                                        <option value="aktywny">aktywny</option>
                                        <option value="nieaktywny">nie aktywny</option>
                                        <option value="jednorazowy">jednorazowy</option>
                                        <option value="podwykonawca">podwykonawca</option>
                                        <option value="zlecenie">zlecenie</option>
                                        <option value="zakończone">zakończone</option>
                                        <option value="inny">inny</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.coop">
                                    <Form.Label>Współpraca</Form.Label>
                                    <Form.Select defaultValue={formData.cooperation}  onChange={handleChange} name={"cooperation"}
                                                 aria-label="Select cooperation mode">
                                        <option value=""></option>
                                        <option value="AGREEMENT">umowa</option>
                                        <option value="NO_AGREEMENT">brak umowy</option>
                                        <option value="ORDER">zlecenie</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.foldernr">
                                    <Form.Label>Nr umowy</Form.Label>
                                    <Form.Control defaultValue={formData.folder_num} type="text" name={"folder_num"} placeholder="numer umowy"
                                                  onChange={handleChange}/>

                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.agreementdate">
                                    <Form.Label>Data umowy</Form.Label>
                                    <Form.Control defaultValue={getDateForInputFromMysqlDate(formData.agreement_date)} type="date" name={"agreement_date"} placeholder="data umowy"
                                                  onChange={handleChange}/>

                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.agrrementenddate">
                                    <Form.Check
                                        type={"checkbox"}
                                        className={"mb-2"}
                                        id={`buildingagreementenddatecheckbox`}
                                        label={"Data końca umowy"}
                                        defaultChecked={formData.agreement_indefinite === 1}
                                        onChange={handleCheckAgrrementEndDate}
                                    />
                                    <Form.Control
                                        disabled={formData.agreement_indefinite === 0}
                                        defaultValue={getDateForInputFromMysqlDate(formData.agreement_end_date)}
                                        type="date"
                                        name={"agreement_end_date"}
                                        placeholder="data końca umowy"
                                        onChange={handleChange}/>

                                </Form.Group>
                            </Col>
                            <Col lg={2}>
                                <Form.Group className="mb-3" controlId="building.projectnr">
                                    <Form.Label>Nr projektowy</Form.Label>
                                    <Form.Control defaultValue={formData.project_num} type="text" name={"project_num"} placeholder="numer projektowy"
                                                  onChange={handleChange}/>

                                </Form.Group>
                            </Col>
                            <Col lg={3}>
                                <Form.Group className="mb-3" controlId="building.coop">
                                    <Form.Label>Ekipa prowadząca</Form.Label>
                                    <TeamSelect teams={teams} onSelect={handleChange} currentTeamId={formData.team_id} />
                                </Form.Group>
                            </Col>
                            <Col lg={12}>
                                <Form.Group className="mb-3" controlId="buildingDescription">
                                    <Form.Label>Opis obiektu / dodatkowe informacje</Form.Label>
                                    <Form.Control defaultValue={formData.description} as="textarea" rows={2} name={"description"} placeholder="opis"
                                                  onChange={handleChange}/>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className={"m-2 border"}>
                            <div className={"border bg-light fs-5"}>
                                Adres obiektu
                            </div>
                            <AddressForm onChange={onChangeAddresState} default={formData.address}/>
                        </Row>

                        <Row className={"m-2 border"}>
                            <div className={"border bg-light fs-5"}>
                                Przeglądy/Inspekcje
                            </div>

                            <InspectionsTable teams={teams} inspections={formData.inspections} onDelete={handleDeleteInspection} handleEditInspection={handleEditInspection} />
                        </Row>

                        <Row className={"m-2 border pb-2"}>
                            <div className={"border bg-light fs-5"}>
                                Osoby i pracownicy obiektu
                            </div>

                            <PersonTable persons={formData.persons} onChange={handlePersonChange} />
                        </Row>
                        {
                            props.building !== undefined && 
                            <Row className={"m-2 border pb-2"}>
                                <div className={"border bg-light fs-5"}>
                                    Załączniki
                                </div>
                                
                                <BuildingFilesForm buildingId={props.building.id} /> 
                                <BuildingProtocolFilesGrid buildingId={props.building.id} />
                                
                            </Row> 
                        }
                        
                        

                    </div>
                    <div className={"ps-4"}>
                        {
                            privilege.edit ?
                                <>
                                    <Link to={"/buildings"} className="btn btn-secondary me-4">Anuluj</Link>
                                    <Button className="me-4" type={"submit"}>Zapisz</Button>
                                </>
                                :
                                <Link to={"/buildings"} className="btn btn-secondary me-4">Powrót</Link>
                        }

                    </div>
                </div>
            </Form>
        )

    return (
        <div>Ładowanie danych...</div>
    )
}

function InspectionsTable({handleEditInspection, onDelete, inspections, teams}){

    const {user} = useAuth();
    const [alert, showAlert] = useState(true)

    const handleChange = (inspection)=>{
        handleEditInspection(inspection)
    }

    const handleAddInspection = ()=>{
        handleEditInspection({id:uuidv4(), name:"", date:"", duration:1, frequency:1, next_inspection_date:"", team_id:""})
    }

    const handleDelete = (id)=>{
        if(!user.isAdmin)
            return window.alert("Tylko administrator może usunąć przegląd.")


        if(!window.confirm("Uwaga. Usunięcie onspekcji spowoduje że nie będzie można ponownie powiązać przeglądów z danym obiektem. Czy chesz usunąć ?"))
            return;

        onDelete(id);
    }




    return (
        <div className={"p-2"}>
            <Alert show={alert} variant={"info"} dismissible onClose={() => showAlert(false)} ><small>Edycja istniejących inspekcji nie zmienia wydarzeń, które już istnieją w kalendarzu. Edycja inspekcji ma wpływ na kolejne wydarzenia, które będą się tworzyć po zakończeniu juz istniejących. Aby zmienić wydarzenie przypisane już do tej inspekcji nalezy je edytowac w kalendarzu. </small> </Alert>
            <Table size={"sm"} bordered className={"w-100"}>
                <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>System</th>
                        <th>Ostatni przegląd <FontAwesomeIcon icon={faInfoCircle} title={"Ustaw datę, system utworzy pierwsze wydarzenie z tą datą. Następne (po realizacji obecnego) będą tworzyć się automatycznie wg. zadanych parametrów."} /> </th>
                        <th>Czas trwania [dni]</th>
                        <th>Częstotliwość w roku</th>
                        <th>Kolejny przegląd <FontAwesomeIcon icon={faInfoCircle} title={"Data najpóźnieszego wydarzenia jakie występuje w terminarzu dla tego systemu."} /> </th>
                        <th>Ekipa</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {
                    inspections?.map((inspection, index)=>{
                        console.log(inspection)
                        const handleInspectionChange = ({target})=>{
                            inspection[target.name] = target.value;
                            handleChange(inspection)
                        }

                        const handleDateSet = ({target})=>{
                            inspection[target.name] = target.value;
                            inspection.next_inspection_date = calculateNextInspectionDate(target.value, inspection.frequency);
                            handleChange(inspection)
                        }

                        const handleChangeFrequency = ({target})=>{
                            inspection[target.name] = target.value;

                            if(inspection.date)
                                inspection.next_inspection_date = calculateNextInspectionDate(inspection.date, target.value);
                            handleChange(inspection)
                        }

                        return  <tr key={inspection.id}>
                            <td>
                                {index+1}
                            </td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"name"} type="text" defaultValue={inspection.name} onChange={handleInspectionChange} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} name={"date"} type="date" defaultValue={inspection.date} onChange={handleInspectionChange} /></td>
                            <td><Form.Control size={"sm"} className={"personTableInput text-center"} name={"duration"} type="number" min={0} step={0.05} defaultValue={inspection.duration} onChange={handleInspectionChange} /></td>
                            <td>
                                <Form.Select size={"sm"} className={"personTableInput"} name={"frequency"} defaultValue={inspection.frequency} aria-label="Select inspection frequency" onChange={handleInspectionChange}>
                                    <option value={12}>co miesiąc</option>
                                    <option value={4}>co kwartał</option>
                                    <option value={2}>co półrocze</option>
                                    <option value={1}>co rok</option>
                                    <option value={0.33}>co trzy lata</option>
                                    <option value={0.2}>co pięć lat</option>
                                    <option value={0}>jednorazowo</option>
                                </Form.Select>
                            </td>
                            <td><Form.Control size={"sm"} className={"personTableInput"} readOnly={true} type="date" defaultValue={inspection.next_inspection_date}  /></td>
                            <td><TeamSelect size={"sm"} currentTeamId={inspection.team_id} teams={teams} onSelect={handleInspectionChange} /></td>
                            <td>
                                <span
                                    className={"fs-5 close-btn"}
                                    onClick={() => { handleDelete(inspection.id) }}
                                    aria-hidden={"true"}>
                                    &times;
                                </span>
                            </td>
                        </tr>
                    })
                }
                </tbody>
            </Table>
            <Button className={"float-end mb-2"} onClick={handleAddInspection} variant={"secondary"} >+</Button>

        </div>
    )
}

function calculateNextInspectionDate(currentDate, frequency){
    const nextinspectionDate = new Date(currentDate);
    const months = 12/frequency;

    nextinspectionDate.setMonth(nextinspectionDate.getMonth() + months);

    return nextinspectionDate.toJSON().split("T")[0]
}

function TeamSelect({teams, currentTeamId, onSelect, size}){

    const options = teams.map(t=><option style={{backgroundColor:t.color}} className={IsTeamInactive(t) ? "worker-inactive" : "worker-active"} key={t.id} value={t.id}>{t.number} {t.leader?.name}</option>);
    const team = teams.find(v=>v.id === currentTeamId)
    const color = (team !== undefined) ? team.color : "#fff";
    const inactive  = (team !== undefined) ? IsTeamInactive(team) : false;


    return <Form.Select size={size}  style={{backgroundColor:color}} className={inactive ? "worker-inactive" : ""} value={currentTeamId} name={'team_id'}  onChange={onSelect} ><option></option>{options}</Form.Select>
}

function IsTeamInactive(team){
    return team.leader?.active === 0;
}